/**
 * TeamFetcher
 *
 * @author Dec Norton <decnorton@gmail.com>
 */
import { Fetcher } from '../../fetchers/fetcher';

export class TeamFetcher extends Fetcher {
    get modelName() {
        return 'Team';
    }

    get resourceName() {
        return 'teams';
    }

    selectOptions(params) {
        return this.all(params).then(response => {
            const teams = response.data;
            const selectOptions = [];

            teams.forEach(team => {
                selectOptions.push({
                    label: team.description,
                    value: team.id,
                });
            });

            // Sort by last name, ascending
            selectOptions.sort((left, right) => {
                return left.label < right.label ? -1 : 1;
            });

            return selectOptions;
        });
    }
}

export function teamFetcherProvider() {
    this.$get = instantiateFetcher;

    instantiateFetcher.$inject = ['$injector'];

    function instantiateFetcher($injector) {
        return $injector.instantiate(TeamFetcher);
    }
}
